import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from './components/NavBar';
import Banner from './components/Banner';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppFloat from "./components/WhatsAppFloat";
import Testemonial from "./components/Testemonial";
import AboutMe from "./components/AboutMe";

function App() {
  return (
   <div className="App">
    <Navbar/>
    <Banner/>
    <Skills/>
    <Projects/>
    <AboutMe/>
    <Contact/>
    <Testemonial />
    <Footer/>
    <WhatsAppFloat />
   </div>
  );
}

export default App;
